// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"63043b53","51":"14addda9","361":"24271b5e","477":"97949f2e","523":"df523400"}[chunkId] + ".chunk.js";
};